<template>
    <div id="duixiang">
        <h5>{{ app ? app.app_name : '' }}</h5>
        <el-container>
            <el-aside width="180px">
                <SubMenu activeIndex="5" />
            </el-aside>
            <el-main>
                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <el-form ref="form" :model="form" :rules="rules">
                            <el-form-item  prop="item_name">
                                <el-input v-model="form.item_name" placeholder="检查项目名称"></el-input>
                            </el-form-item>
                            <el-form-item v-for="(option, index) in form.options" :label="'选项'" :key="option.key">
                                <el-input v-model="option.option_name">
                                    <el-button slot="append" icon="el-icon-close" @click.prevent="removeOption(option)"></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-row type="flex" justify="start">
                                <el-button @click="addOption" icon="el-icon-plus">新增选项</el-button>
                            </el-row>
                            </el-form-item>
                            <el-form-item>
                                <el-row type="flex" justify="start">
                                <el-button @click="submit" type="primary">确认提交</el-button>
                                 </el-row>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-row>
                     <el-table :data="items" border style="width: 100%">
                    <el-table-column label="检查项目名称" width="150">
                        <template slot-scope="scope">
                            <span>{{ scope.row.item_name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center">
                        <template slot="header" slot-scope="scope">
                            操作
                        </template>
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.$index, scope.row)"></el-button>
                            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog title="修改检查项目" :visible.sync="dialogVisible">
                    <el-form ref="dialogForm" :model="dialogForm" label-width="100px" :rules="rules">
                        <el-form-item label="检查项目名称" prop="item_name">
                            <el-input v-model="dialogForm.item_name"></el-input>
                        </el-form-item>
                        <el-form-item v-for="(option, index) in dialogForm.options" :label="'选项'" :key="option.key">
                            <el-input v-model="option.option_name">
                                <el-button slot="append" icon="el-icon-close" @click.prevent="removeOptionDialog(option)"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="addOptionDialog">新增选项</el-button>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button @click="handleEditSubmit" type="primary">确认修改</el-button>
                    </div>
                </el-dialog>
                </el-row>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import axios from 'axios'
import config from '../config.js'
import { Tag } from 'iview';
import SubMenu from './SubMenu.vue'
export default {
    components: {
        Tag,
        SubMenu,
    },
    data() {
        return {
            app_id: '',
            app: null,
            items: [],
            dialogVisible: false,
            form: {
                item_id: '',
                item_name: '',
                options: [],
                index: ''
            },
            dialogForm: {
                item_id: '',
                item_name: '',
                options: [],
                index: ''
            },
            rules: {
                item_name: [
                    { required: true, message: '请输入检查项目名称', trigger: 'blur' },
                ],
                option_name: [
                    { required: true, message: '请输入选项名称', trigger: 'blur' },
                ]
            }
        }

    },
    created() {
        this.app_id = this.$route.params.app_id
        if (!localStorage.getItem(this.app_id)) {
            this.getApp()
        } else {

            let app = JSON.parse(localStorage.getItem(this.app_id))
            this.setApp(app)
        }
        this.getItem()

    },
    methods: {
        getApp() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.app = res
            }).catch((err) => {
                //console.log(err);
            })
        },
        setApp(app) {
            this.app = app

        },
        submit() {
            let from_data = this.form
            //console.log(from_data)
            let _this = this
            axios({
                    method: 'post',
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    url: config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id + '/items',
                    data: from_data
                })
                .then(function(response) {
                   
                    _this.$message({
                        message: '检查项目添加成功',
                        type: 'success'
                    });
                    //console.log(_this.form)
                    _this.items.push(_this.form)
                    // _this.form.item_name = ''
                    // _this.form.options = []
                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })
        },
        pageToItemSetting(){
            this.$router.push({
                name:'itemsetting',
                app_id:this.app_id
            })
        },
        
        getItem() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app.app_id + '/items'
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.items = res
            }).catch((err) => {
                //console.log(err);
            })
        },
        handleEdit(index, item) {
            this.dialogVisible = true
            this.dialogForm.item_id = item.item_id
            this.dialogForm.item_index = index
            this.dialogForm.item_name = item.item_name
            this.dialogForm.options = item.options
        },
        addOption() {
            this.form.options.push({
                option_name: '',
                key: Date.now()
            });
        },
        removeOption(item) {
            var index = this.form.options.indexOf(item)
            if (index !== -1) {
                this.form.options.splice(index, 1)
            }
        },
        addOptionDialog() {
            this.dialogForm.options.push({
                option_name: '',
                key: Date.now()
            });
        },
        removeOptionDialog(item) {
            var index = this.dialogForm.options.indexOf(item)
            if (index !== -1) {
                this.dialogForm.options.splice(index, 1)
            }
        },
        handleEditSubmit() {
            let data = this.dialogForm
            let _this = this
            axios({
                    method: 'put',
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    url: config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id + '/items/' + this.dialogForm.item_id,
                    data: data
                })
                .then(function(response) {

                    _this.$message({
                        message: '检查项目修改成功',
                        type: 'success'
                    });
                    _this.items[_this.dialogForm.item_index].item_name = _this.dialogForm.item_name
                    _this.dialogForm.item_name = ''
                    _this.dialogForm.options = []
                    _this.dialogVisible = false
                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })
        },

        handleDelete(index, item) {
            let _this = this;
            this.$confirm('此操作将永久删除该检查项, 是否继续?', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                axios({
                        method: 'delete',
                        headers: {
                            "Authorization": localStorage.getItem('token')
                        },
                        url: config.base_url + '/yun_table/yun_jiancha/apps/' + _this.app_id + '/items/' + item.item_id
                    }).then(function(response) {
                        //console.log(response)

                        _this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        _this.items.splice(index, 1)
                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>